
import useViewer from '../../hooks/useViewer'
import useNavigation from '../../hooks/useNavigation'
import useAssets from '../../hooks/useAssets'
import useSelectedGroupSatellite from '../../hooks/useSelectedGroupSatellite'
import useThermalHeatmap from '../../hooks/useThermalHeatmap'
import MultiselectGroup from '../multi-select-group/MultiselectGroup'
import ScenarioButtonsGroups from '../scenario-buttons-group/ScenarioButtonsGroups'
import ViewerSettings from '../../../../CommonComponents/ViewerSettings'
import './ScenarioFooter.scss'
import { VIEW_TYPES } from '../../../../../utils/constants'
import OrbitAnimationTimeline from '../scenario-timeline/orbit-animation-timelite/OrbitAnimationTimeline'
import { Fragment, useEffect, useMemo, useState } from 'react'
import useOrbitAnimationDetails from '../../hooks/useOrbitAnimationDetails'
import useScenarioResponse from '../../hooks/useScenarioResponse'
import { SCENARIO_DEPLOYMENT_TYPES } from '../../../constants'
import SubSystemBadge from './SubSystemBadge'

const ScenarioFooter = () => {
    const { viewer } = useViewer()
    const { scenarioId } = useNavigation()
    const { schedule } = useAssets()
    const { selectedGroupSatellite } = useSelectedGroupSatellite()
    const { orbitAnimationDetails, getViewerCurrentTime } = useOrbitAnimationDetails()
    const { scenarioResponse } = useScenarioResponse()

    const [viewerEpoch, setViewerEpoch] = useState<number>(0)

    const showAnimationDetails = useMemo(() => orbitAnimationDetails.showAnimationDetails, [orbitAnimationDetails.showAnimationDetails])
    const scenarioDeploymentType = useMemo(() => scenarioResponse?.scenarioDeploymentType, [scenarioResponse?.scenarioDeploymentType])
    const openScenario = useMemo(() => scenarioDeploymentType === SCENARIO_DEPLOYMENT_TYPES.TRUETWIN_COMMAND_CENTER, [scenarioDeploymentType])

    const selectedSatelliteId = useMemo(() => selectedGroupSatellite?.satelliteId, [selectedGroupSatellite?.satelliteId])
    const scheduleEvents = useMemo(() => (selectedSatelliteId && schedule.data) ? schedule.data[selectedSatelliteId] || [] : [], [selectedSatelliteId, schedule.data])

    useEffect(() => {
        let rafId: number | null = null
        const tick = () => {
            const now = getViewerCurrentTime?.() || 0
            setViewerEpoch((prev) => (prev === now ? prev : now))
            rafId = requestAnimationFrame(tick)
        }
        rafId = requestAnimationFrame(tick)
        return () => {
            if (rafId) cancelAnimationFrame(rafId)
        }
    }, [getViewerCurrentTime])

    const activeTasks = useMemo(() => {
        const activeEvents = scheduleEvents.filter(event => event.startTime <= viewerEpoch && event.endTime >= viewerEpoch && event.status === 'Scheduled')
        const tasks: { taskName: string; commandName: string | null }[] = []
        for (const event of activeEvents) {
            const taskName = (event as any)?.taskName || 'Task'
            const commandsList = (event as any)?.commandsList || []
            const activeCmd = commandsList.find(cmd => {
                const cmdStartTime = cmd?.epoch || 0
                const cmdEndTime = cmdStartTime + (cmd?.duration || 0)
                return cmdStartTime <= viewerEpoch && cmdEndTime >= viewerEpoch
            })
            tasks.push({ taskName, commandName: activeCmd?.name || null })
        }
        return tasks
    }, [scheduleEvents, viewerEpoch])

    const { isThermalFullscreen } = useThermalHeatmap()

    if (isThermalFullscreen) return null

    return (
        <div className='scenario__footer__container'>
            {showAnimationDetails && activeTasks.length > 0 && (
                <div className='subsystem-badge-stack'>
                    {activeTasks.map((task, index) => (
                        <SubSystemBadge
                            key={index}
                            title={task.taskName}
                            value={task.commandName}
                        />
                    ))}
                </div>
            )}
            {!openScenario &&
                <Fragment>
                    <MultiselectGroup />
                    <ScenarioButtonsGroups />
                    <OrbitAnimationTimeline />
                    {/* <ThermalHeatMap /> */}
                </Fragment>
            }
            {!showAnimationDetails &&
                <ViewerSettings className='footer__setting__button' disabled={!scenarioId} viewer={viewer} viewerId={scenarioId || '123'} viewType={VIEW_TYPES.SIMULATE} />
            }
        </div>
    )
}

export default ScenarioFooter
